/* Print edition links
 * ----------------------------------------------------------
 * Each Herald issue has a one-sheet PDF for churches to print, made by
 * tools/print/watch.js on the server. Beside each PDF is a small JSON status:
 *   {fits, pages, trim_words, pdf, updated_at, rendered_at}
 * The theme cannot know whether a file exists, so this reads that status and
 * shows the right thing. All the words are in the templates (post.hbs,
 * print.hbs); this only unhides them.
 *
 * Three places:
 *   - a published issue (post.hbs): the PDF link, if there is a PDF. Never a warning.
 *   - Doug's preview (/p/{uuid}/): the same link plus whether it fits on one
 *     sheet, "too long, trim about N words", or "updating" while the server
 *     catches up with an edit. Drafts live under preview/{uuid}.
 *   - /print/ (print.hbs, the short link in every email): straight on to the
 *     newest issue's PDF.
 *
 * Ghost serves /content/files/ with a year-long cache, so the status is
 * fetched with no-store and the PDF link carries ?v=<rendered_at>: an issue
 * edited after it went out must not reach a church as the old file.
 */
(function () {
    var box = document.querySelector('[data-hh-print]');
    if (!box || !window.fetch) return;

    var root = '/content/files/print/';
    var slug = box.getAttribute('data-slug');
    var uuid = box.getAttribute('data-uuid');
    var isPreview = /^\/p\//.test(window.location.pathname);
    var isRedirect = box.hasAttribute('data-hh-print-go');

    function part(name) { return box.querySelector('[data-hh-print-' + name + ']'); }
    function show(name) { var el = part(name); if (el) el.hidden = false; return el; }

    function load(base) {
        return fetch(root + base + '.json', {cache: 'no-store'}).then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.json().then(function (status) { status.base = base; return status; });
        });
    }

    // A draft's files are under its uuid; once scheduled or published, its slug.
    var lookup = isPreview && uuid
        ? load('preview/' + uuid).catch(function () { return load(slug); })
        : load(slug);

    lookup.then(function (status) {
        var href = root + status.base + '.pdf?v=' + encodeURIComponent(status.rendered_at || '');

        if (isRedirect) {
            if (status.pdf) { window.location.replace(href); return; }
            var button = part('ok'); if (button) button.hidden = true;
            return;
        }

        var edited = box.getAttribute('data-updated');
        var behind = isPreview && edited && new Date(status.updated_at) < new Date(edited) - 1000;

        // The "Print edition" snippet already says this in the letter. In the
        // email it has to go to /print/ (the newest issue); on this page, point
        // it at this issue's own PDF and leave the theme's link out, so the
        // reader is not offered the same thing twice.
        var inLetter = [];
        var links = document.querySelectorAll('.gh-content a[href]');
        for (var i = 0; i < links.length; i++) {
            if (/^\/print\/?$/.test(links[i].pathname) && links[i].hostname === window.location.hostname) inLetter.push(links[i]);
        }

        if (status.pdf && !behind) {
            if (inLetter.length) {
                for (var j = 0; j < inLetter.length; j++) inLetter[j].href = href;
            } else {
                var link = show('ok');
                if (link) link.href = href;
            }
        }
        if (isPreview) {
            if (behind) show('wait');
            else if (status.fits) show('fits');
            else {
                var trim = part('trim');
                if (trim) trim.textContent = status.trim_words;
                show('long');
            }
        }
        box.hidden = !box.querySelector('[data-hh-print-ok]:not([hidden]), .hh-print-note:not([hidden])');
    }).catch(function () {
        // No status yet. On a preview that means the server has not caught up.
        if (isPreview && !isRedirect) { show('wait'); box.hidden = false; }
    });
})();
